import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import axios from 'axios'
import VueAxios from 'vue-axios'

import router from '@/router'
// Helper para obtener el id del año académico actual desde los getters
const getIdAnioAcademicoActual = (getters) => {
	const anios = getters.getAniosAcademicos;
	const anioActual = Array.isArray(anios) ? anios.find(a => a && a.anioActual === true) : null;
	return anioActual ? anioActual.clave : null;
};
const state = {
	logged: !!window.localStorage.getItem('_token'),
	nombreUsuario: '',
	rgpd: '',
	token: '',
	godMode: window.localStorage.getItem('godMode') || false,
	revisarPerfil: false,
	istutor: false,
	isdirector: false
};

const getters = {
	getLogged: state => state.logged,
	getUserName: state => state.nombreUsuario,
	getIsTutor: state => state.istutor,
	getIsDirector: state => state.isdirector,
	getGodmodeStatus: state => (Boolean(state.godMode)),
	getRevisarPerfil: state => state.revisarPerfil,
};

const actions = {
	login: ({ commit, dispatch }, user) => {

		let type = (user.eAmbito == 'PrivadoEmpresa') ? 'Empresa' : 'Alumno';

		return new Promise((resolve, reject) => {

			axios.post(`/api/TutorAcademico/logaUsuario`, user).then(response => {
				response = response.data;
				dispatch('loggedThings', response);
				resolve(true);
			})
				.catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
					reject(false);
				});
		});
	},
	loginSAML: ({ commit, dispatch }, data) => {
		return new Promise((resolve, reject) => {

			axios.post("api/TutorAcademico/validaRespuestaLoginIntegrado", { "respuesta": data }).then(response => {
				if (response.data.status == 0) {

					window.localStorage.setItem('loggedby', 'saml');

					dispatch('loggedThings', response.data);
				} else {
					commit('setError', response.data.status);
				}

			})
				.catch(function (error) {
					commit('setError', 500);
					reject(false);
					dispatch('sendErrorServer', error.response);
				});
		});
	},
	loggedThings: ({ dispatch, commit, getters }, response) => {


		if (response.status == 0) {

			let token = response.datos.token;

			window.localStorage.setItem('_token', token);
			window.localStorage.setItem('_istutor', response.datos.paraAsignacionPracticas);
			window.localStorage.setItem('_isdirector', response.datos.paraValidacionOfertas);


			axios.defaults.headers.common['authorization'] = `Bearer ${token}`;
			commit('setUser');
			dispatch('requestAllData');
			commit('setNombreUsuario');

			if (!!getters.getBrand.checkPerfil) {
				dispatch('checkPerfil');
			}

			if (response.datos.idIdiomaPreferido) {
				window.localStorage.setItem('_idIdiomaPreferido', response.datos.idIdiomaPreferido);
			}

			if (!!window.sessionStorage.getItem('idPractica')) {
				router.push(getters.getTexts.enlaces.ficha + '/' + window.sessionStorage.getItem('idPractica'));
				window.sessionStorage.removeItem('idPractica');
			} else {
				router.push('/');
			}


		} else {

			commit('setError', response.status);
		}

	},
	checkTokenExpiration: ({ commit }) => {

		return new Promise((resolve, reject) => {

			let token = window.localStorage.getItem('_token');

			if (!!token) {
				const jwtDecode = require('jwt-decode');
				let data = jwtDecode(token);
				let now = Math.round((new Date().getTime() / 1000));
				if (now > data.exp) {
					window.localStorage.removeItem('_token');

					reject("sesion finalizada")
				} else {
					resolve(true);
				}
			} else {
				commit('setError', 2);
			}

			commit('setUser');

		});
	},
	logout: ({ commit, getters }) => {
		return new Promise((resolve, reject) => {
			window.localStorage.removeItem('_token');
			window.localStorage.removeItem('_isdirector');
			window.localStorage.removeItem('_istutor');



			if (getters.getBrand.logoutSSO && window.localStorage.getItem('loggedby') == 'saml') {
				window.location = getters.getBrand.logoutSSO;
			} else {
				resolve(true);
				commit('setUser');
			}

		});
	},
	recuerdoPass: function ({ commit, dispatch }, usuario) {
		return new Promise((resolve, reject) => {

			let data = { "usuario": usuario };

			axios.post('/api/TutorAcademico/solicitarReseteoPassword', data).then(response => {
				if (response.data.status == 0) {
					resolve(true);
					commit('setError', 504);
				} else {
					commit('setError', response.data.status);
				}
			})
				.catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
		});
	},
	sendPassword: function ({ commit, dispatch }, data) {
		return new Promise((resolve, reject) => {

			axios.post('/api/TutorAcademico/restablecerPassword', data).then(response => {
				if (response.data.status == 0) {
					resolve(true);
					commit('setError', 505);
				} else {
					commit('setError', response.data.status);
				}
			})
				.catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
		});
	},
	checkPerfil: function ({ commit, dispatch }) {

		return new Promise((resolve, reject) => {

			axios.get('/api/TutorAcademico/faltanDatosPersonales').then(response => {
				if (response.data.status == 0) {
					if (!!response.data.datos) {
						commit('setRevisarPerfil', true)
					}
				} else {
					commit('setError', response.data.status);
				}
			})
				.catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
		});

	},
	hideRevisarPerfil: function ({ commit }) {
		commit('setRevisarPerfil', false);
	},
	requestAllData: ({ dispatch, getters, commit }) => {
		commit('setNombreUsuario');
		commit('setUser');
		commit('setFavoritos');
		dispatch('requestTotales');
		dispatch('requestValidaciones');
		const idAnioAcademico = getIdAnioAcademicoActual(getters);
		if (idAnioAcademico != null) {
			dispatch('requestTutoradasHistorico', idAnioAcademico);
		}
		// dispatch('requestFirmante');
		dispatch('requestEstadosValidacion');
		dispatch('requestDocumentos');
		dispatch('requestDominios');

		if (getters.getIsDirector) {
			dispatch('requestAprobaciones');
		}

	},
	refreshData({ dispatch }) {
		dispatch('requestTotales');
		dispatch('requestValidaciones');
		const idAnioAcademico = getIdAnioAcademicoActual(getters);
		if (idAnioAcademico != null) {
			dispatch('requestTutoradasHistorico', idAnioAcademico);
		}
		// dispatch('requestFirmante');F
	},
	activarGodMode: function ({ commit }) {
		commit('setGodmode', true)
	},
	desactivarGodMode: function ({ commit }) {
		commit('setGodmode', false)
	}
};

const mutations = {
	setUser(state) {


		if (!!window.localStorage.getItem('_token')) {

			const token = window.localStorage.getItem("_token");
			state.istutor = ((window.localStorage.getItem("_istutor")) == 'true');
			state.isdirector = ((window.localStorage.getItem("_isdirector")) == 'true');

			const jwtDecode = require('jwt-decode');

			axios.defaults.headers.common['authorization'] = `Bearer ${token}`;
			axios.defaults.headers.get['authorization'] = `Bearer ${token}`;

			let user = jwtDecode(token);

			state.logged = true;


		} else {
			state.logged = false;
			router.push("/login");
		}
	},
	setLogged(state, logged) {
		state.logged = logged;
	},
	setNombreUsuario(state) {

		if (!!window.localStorage.getItem("_token")) {
			const token = window.localStorage.getItem("_token");
			const jwtDecode = require('jwt-decode');
			let user = jwtDecode(token);
			state.nombreUsuario = `${user.unique_name} ${user.family_name}`;
		}
	},
	setGodmode(state, status) {
		if (status) {
			window.localStorage.setItem('godMode', true);
			state.godMode = true;
		} else {
			window.localStorage.removeItem('godMode');
			state.godMode = false;
		}
	},
	setRevisarPerfil(state, status) {
		state.revisarPerfil = status;
	}
};

export default {
	state,
	getters,
	actions,
	mutations
};


// WEBPACK FOOTER //
// ./src/store/auth.js